import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NoteProfile } from 'src/app/models/noteProfile';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.css']
})
export class NoteComponent implements OnInit {
  @Input() profile: NoteProfile;
  @Input() inputForm: FormGroup;
  @Output() changes: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onChange(event) {
    this.changes.emit(event);
  }

}
